import React from 'react';
import { Modal , Button } from 'react-bootstrap';
import Input from '../../../../Common/form/input';
import Select from '../../../../Common/form/select';
import Checkbox from '../../../../Common/form/checkbox';
import Datepicker from "../../../../Common/form/datepicker";

const renderCheckbox = (name, label, handleChange, data) => {
  return (
    <Checkbox
      name={name}
      checked={(data[name])}
      value={data[name]}
      label={label}
      onChange={handleChange}
      justifyContent={'start'}
    />
  )
}

const renderInput = (name, label, handleChange, data, type, handleBlur) => {
  const inputSize =  (name === 'radio_qty') ? 'sm' : undefined;
  return (
    <Input
      type={type}
      label={label}
      name={name}
      value={data[name]}
      onChange={handleChange}
      onBlur={handleBlur}
      inputsize={inputSize}
    />
  )
}

const renderSelect = (name, label, handleChange, data, options) => {
  return (
    <Select
      name={name}
      label={label}
      value={data[name]}
      options={options}
      onChange={handleChange}
    />
  )
}

const renderDatepicker = (name, label, handleChange, handleFocus, data) => {
  const dateSelected = new Date();
  if (data[name]) {
    const time = data[name].split(":");
    dateSelected.setHours(time[0], time[1], 0, 0);
  }

  return (
    <Datepicker
      selected={data[name]? dateSelected : null}
      name={name}
      label={label}
      className="datepicker form-control form-control-sm"
      onChange={handleChange}
      onFocus={ ({ currentTarget: input }) => handleFocus(name)}
      showTimeSelect
      showTimeSelectOnly
      timeIntervals={15}
      timeFormat="HH:mm"
      dateFormat="HH:mm"
    />
  )
};

const validHours = (data) => {
  if (data.start_time && data.end_time) {
    const start = new Date();
    const startTime = data.start_time.split(":");
    start.setHours(startTime[0], startTime[1], 0, 0);

    const end = new Date();
    const endTime = data.end_time.split(":");
    end.setHours(endTime[0], endTime[1], 0, 0);

    return start < end;
  }
  return true;
}

const validateTimes = (data) => {
  let validTimes = true;
  if ((data.start_time && !data.end_time) || (!data.start_time && data.end_time)) {
    validTimes =  false;
  }
  return validTimes;
}

const VenueConfigurationPositionForm = ({ isOpen, onAfterOpen, onRequestClose, closeModal, data, handleChange, handleChangeDatepicker, handleFocusDatepicker, positionsTypeOptions, handleSave, handleBlur }) => {
  const qtyListOptions =  [{ id: '', name: '' }];
  for (let i = 1; i <= 50; i++) {
    qtyListOptions.push(
      { id: i.toString(), name: i.toString() }
    )
  }

  return (
    <Modal show={isOpen} onHide={onRequestClose} className="modal-configuration-position-form">
      <Modal.Header closeButton>
        <Modal.Title>
        <i className="fas fa-shield-alt"></i>&nbsp;{!data.id ? 'Add Position' : 'Edit Position'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-12">
            {renderInput('assignment_name', 'Assignment Name', handleChange, data, 'text')}
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            {renderDatepicker('start_time', 'Start Time', handleChangeDatepicker, handleFocusDatepicker, data)}
          </div>
          <div className="col-4">
          </div>
          <div className="col-4">
            {renderDatepicker('end_time', 'End Time', handleChangeDatepicker, handleFocusDatepicker, data)}
          </div>
          </div>
          <div className="row">
            <div className="col-8">
              {renderSelect('position_id', 'Position Type', handleChange, data, positionsTypeOptions)}
            </div>
            <div className="col-4">
              {renderSelect('qty', 'Qty', handleChange, data, qtyListOptions)}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <h3 className="form-group-label">Equipment</h3>
            </div>
            <div className="col-12 d-flex justify-content-between align-items-center">
              <div className="col-3">
                {renderCheckbox('blazer', 'Blazer', handleChange, data)}
              </div>
              <div className="col-3">
                {renderCheckbox('coat', 'Coat', handleChange, data)}
              </div>
              <div className="col-3">
                {renderCheckbox('shirt', 'Shirt', handleChange, data)}
              </div>
              <div className="col-3">
                {renderCheckbox('traffic', 'Traffic', handleChange, data)}
              </div>
            </div>
            <div className="col-12 d-flex justify-content-start align-items-baseline">
              <div className="col-3 pr-0">
                {renderCheckbox('radio', 'Radio', handleChange, data)}
              </div>
              <div className="col-3 pl-0">
                {data['radio'] &&
                  <div className="input-radio-qty">
                    {renderInput('radio_qty', 'Radio Qty', handleChange, data, 'number')}
                  </div>
                }
              </div>
            </div>
          </div>

        {!validHours(data)
          ? <div className="row justify-content-center">
            <div className="col-sm-11">
              <p className="disclaimer text-center warning">
                Start Time has been set after End Time. This means the shift will end the next day. Only proceed if this is the expected result.
              </p>
            </div>
          </div>
          : null
        }
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>Cancel</Button>
        <Button variant="success" disabled={!data.assignment_name || !data.position_id || !data.qty || !validateTimes(data)}
                onClick={() => handleSave()}>
          {!data.id ? 'Add Position' : 'Edit Position'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
export default VenueConfigurationPositionForm;
